
import { css } from 'lit';
export default css`
.grid-wrapper{
  --gap-count:calc(var(--grid-column--max-count) - 1);
  --total-gap-width:calc(var(--gap-count) * var(--grid-layout-column-gap));
  --grid-item--max-width:calc(
    (100% - var(--total-gap-width)) / var(--grid-column--max-count)
  );
  grid-gap:var(--grid-layout-column-gap);
  column-gap:var(--grid-layout-horizontal-gap);
  row-gap:var(--grid-layout-vertical-gap);
  grid-row-gap:var(--grid-layout-row-gap);
  grid-column-gap:var(--grid-layout-column-gap);

  display:grid;
  grid-template-columns:repeat(
    auto-fill,
    minmax(max(var(--grid-item--min-width), var(--grid-item--max-width)), 1fr)
  );
  justify-content:center;
}

.mobile-carousel{
  display:flex;
  flex-wrap:nowrap;
  overflow-x:auto;
  justify-content:start;
  padding-bottom:2rem;
}

@media (min-width: 992px){

.mobile-carousel{
    display:grid;
    oveflow:auto;
    justify-content:center;
    padding-bottom:0;
    overflow-x:hidden
}
  }

.mobile-carousel ::slotted(*){
    min-width:var(--grid-item--min-width);
  }

.equal-height{
  grid-auto-rows:1fr;
}

.equal-height > *{
    height:100%;
  }

.justify-self > *{
    justify-self:var(--justify-self);
  }

.align-self > *{
    align-self:var(--align-self);
  }

:host(.span-two-columns) ::slotted(:first-child){
  grid-column:span 2;
}

:host(.span-two-columns) .equal-at-plus{
    grid-auto-rows:1fr;
  }

:host(.span-two-columns) .equal-at-plus > *{
      height:100%;
    }
`;